import { BookOpen } from 'lucide-react';

export const EmptyState = () => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <BookOpen className="h-16 w-16 text-muted-foreground mb-4" />
      <h2 className="text-xl font-semibold text-card-foreground mb-2">
        No masterclasses available
      </h2>
      <p className="text-muted-foreground max-w-md">
        You don't have access to any masterclasses yet. Contact your administrator or use an access
        link to get started.
      </p>
    </div>
  );
};
